import { useFieldHelper, FieldProps, TextField } from 'framework/ui/field';
import React from 'react';
import { InputTooltip } from 'framework/ui/layout';

const PreviousPaidLeaveBalanceField = (props: FieldProps<any>) => {
  const { getValue } = useFieldHelper(props);
  const displayedValue = `${getValue()} working days`;
  const { label: labelFromProps, source: sourceFromProps, tooltip: tooltipFromProps } = props;

  return (
    <TextField
      {...props}
      label={
        <>
          {labelFromProps}
          <InputTooltip source={sourceFromProps} message={tooltipFromProps} />
        </>
      }
      value={displayedValue}
    />
  );
};

export default PreviousPaidLeaveBalanceField;
